import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const StayCommisions = () => {
  return (
    <>
      <Box className="headingBtnWrap">
        <Typography variant="h1">Commisions</Typography>
      </Box>
    </>
  )
}

export default StayCommisions
